<div class="row">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">

        <!-- Comercial -->
        <mat-card class="mat-elevation-z8 w-100" *ngIf="isComercial">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">

                    <!-- Linha 1 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Centro de Ensaque
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <mat-select #txtCentroEnsaque formControlName="centro_ensaque" disableCenteringOption
                                    (selectionChange)="getDataEt004()" disabled class="InputBlockColor">
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterCentro($event.target.value)">
                                    <mat-option *ngFor="let item of listCentro" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <!-- <mat-error>{{hasErrorFormControl(formulario.controls.centro_ensaque)}}</mat-error> -->
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Centro de Produção
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <mat-select #txtCentroProducao formControlName="centro_producao" disableCenteringOption
                                    class="InputUnblockColor">
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterCentro($event.target.value)">
                                    <mat-option *ngFor="let item of listCentro" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.centro_producao)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Contrato Jurídico
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtContrato" #txtContrato maxlength="50"
                                    formControlName="contrato_juridico" (blur)="getDataPc003()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">Ex Padrão: Safras até VE24:
                                    CVE-I2135. A partir de IN24: M2I2435 (Em caso de mais de um contrato, separar por ;
                                    e os dados serão puxados referente ao primeiro contrato)</mat-hint>
                                <mat-hint align="end">{{txtContrato.value.length}} / 50</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.contrato_juridico)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 2 -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Ordem de Processo
                                </mat-label>
                                <input matInput id="txtOrdemProcesso" #txtOrdemProcesso maxlength="20"
                                    formControlName="ordem_processo">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtOrdemProcesso.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.ordem_processo)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Safra</mat-label>
                                <mat-select #txtSafra formControlName="safra" (selectionChange)="getPC003DataEmit()"
                                    disableOptionCentering>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..." (keyup)="createFilterSafra($event.target.value)">
                                    <mat-option *ngFor="let item of listSafra" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Centro de Campo</mat-label>
                                <input matInput id="txtCentroCampo" #txtCentroCampo maxlength="4"
                                    formControlName="centro_campo" [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtCentroCampo.value.length}} / 4</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.centro_campo)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 3 -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Híbrido</mat-label>
                                <input matInput id="txtHibrido" #txtHibrido maxlength="80" [readonly]="true"
                                    formControlName="hibrido_rnc" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtHibrido.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.hibrido_rnc)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Espécie</mat-label>
                                <input matInput id="txtEspecie" #txtEspecie maxlength="20" formControlName="especie"
                                    [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtEspecie.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.especie)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Lote de Origem
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtLoteOrigem" #txtLoteOrigem maxlength="10"
                                    formControlName="lote_origem" (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    Somente números, letras e undelines são permitidos(tamanho exato de 10)
                                </mat-hint>
                                <mat-hint align="end">{{txtLoteOrigem.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.lote_origem)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 5 -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Lote de Saída
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtLoteSaida" #txtLoteSaida maxlength="10"
                                    formControlName="lote_saida" (blur)="makeCalculations()"
                                    (blur)="lotesSaidaQua042Exists()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtLoteSaida.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.lote_saida)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Processo de Origem
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <mat-select #txtProcessoOrigem formControlName="processo_origem" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterProcesso($event.target.value)">
                                    <mat-option *ngFor="let item of listProcesso" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.processo_origem)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Código do Material
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtCodigoMaterial" #txtCodigoMaterial maxlength="20"
                                    formControlName="codigo_material">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtCodigoMaterial.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.codigo_material)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 6 -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Safra Boletim
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtSafraBoletim" #txtSafraBoletim maxlength="9"
                                    formControlName="safra_boletim">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">Formato Ano/Ano (Ex: 2020/2021)
                                </mat-hint>
                                <mat-hint align="end">{{txtSafraBoletim.value.length}} / 9</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.safra_boletim)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Validade
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtValidade" #txtValidade maxlength="8" formControlName="validade">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">Formato (MES/ANO) é aceito Ex:
                                    JAN/2020
                                </mat-hint>
                                <mat-hint align="end">{{txtValidade.value.length}} / 8</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.validade)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md" *ngIf="!formulario.controls.silo_classificado_ou_big_bag.disabled">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Silo Classificado ou Big Bag</mat-label>
                                <input matInput id="txtSiloClassificadoBigBag" #txtSiloClassificadoBigBag maxlength="10"
                                    formControlName="silo_classificado_ou_big_bag">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtSiloClassificadoBigBag.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.silo_classificado_ou_big_bag)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 8 -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                              floatLabel="{{ formFieldFloatLabel }}">
                              <mat-label class="InputLabelColor">Peneira</mat-label>
                              <mat-select #txtPeneira formControlName="peneira" disableCenteringOption>
                                <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                                  (keyup)="createFilterPeneira($event.target.value)" />
                                <mat-option *ngFor="let item of listPeneira" [value]="item.name">
                                  {{ item.name | uppercase }}
                                </mat-option>
                              </mat-select>
                              <i matSuffix class="{{ iconEnableField }}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                              <mat-error>{{
                                hasErrorFormControl(formulario.controls.peneira)
                                }}</mat-error>
                            </mat-form-field>
                          </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Grupo Peneira</mat-label>
                                <input matInput id="txtGrupoPeneira" #txtGrupoPeneira maxlength="20"
                                    formControlName="grupo_peneira" [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtGrupoPeneira.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.grupo_peneira)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tipo Ensaque
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <mat-select #txtTipoEnsaque formControlName="tipo_ensaque" disableCenteringOption
                                    (selectionChange)="makeCalculations()">
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterTipoEnsaque($event.target.value)">
                                    <mat-option *ngFor="let item of listTipoEnsaque" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.tipo_ensaque)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>



        <!-- basica -->
        <mat-card class="mat-elevation-z8 w-100" *ngIf="isBasica">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">
                    <!-- Linha 1 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Centro de Ensaque
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <mat-select #txtCentroEnsaque formControlName="centro_ensaque" disableCenteringOption
                                    (selectionChange)="getDataEt004()" disabled class="InputBlockColor">
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterCentro($event.target.value)">
                                    <mat-option *ngFor="let item of listCentro" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">N° de campo (Básica)
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtNumeroCampo" #txtNumeroCampo maxlength="10" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="getPC003DataEmit()" formControlName="numero_campo">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtNumeroCampo.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.numero_campo)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 2 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Contrato Jurídico
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtContrato" #txtContrato maxlength="50"
                                    formControlName="contrato_juridico" disabled class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="end">{{txtContrato.value.length}} / 50</mat-hint>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.contrato_juridico)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Ordem de Processo
                                </mat-label>
                                <input matInput id="txtOrdemProcesso" #txtOrdemProcesso maxlength="20"
                                    formControlName="ordem_processo">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtOrdemProcesso.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.ordem_processo)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 3 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Safra</mat-label>
                                <mat-select #txtSafra formControlName="safra" (selectionChange)="getPC003DataEmit()"
                                    disableOptionCentering>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..." (keyup)="createFilterSafra($event.target.value)">
                                    <mat-option *ngFor="let item of listSafra" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Centro de Campo</mat-label>
                                <input matInput id="txtCentroCampo" #txtCentroCampo maxlength="4"
                                    formControlName="centro_campo" [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtCentroCampo.value.length}} / 4</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.centro_campo)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 4 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Híbrido/Linhagem</mat-label>
                                <input matInput id="txtHibrido" #txtHibrido maxlength="80" [readonly]="true"
                                    formControlName="hibrido_rnc" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtHibrido.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.hibrido_rnc)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Espécie</mat-label>
                                <input matInput id="txtEspecie" #txtEspecie maxlength="20" formControlName="especie"
                                    [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtEspecie.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.especie)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Geração</mat-label>
                                <input matInput id="txtGeracao" #txtGeracao maxlength="20" formControlName="geracao"
                                    [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtGeracao.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.geracao)}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                    </div>

                    <!-- Linha 5 -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Lote de Origem
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtLoteOrigem" #txtLoteOrigem maxlength="10"
                                    formControlName="lote_origem">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    Somente letras, números e undelines são permitidos(tamanho exato de 10)
                                </mat-hint>
                                <mat-hint align="end">{{txtLoteOrigem.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.lote_origem)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Lote de Saída
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtLoteSaida" #txtLoteSaida maxlength="10"
                                    formControlName="lote_saida" (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtLoteSaida.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.lote_saida)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 6 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Código do Material</mat-label>
                                <input matInput id="txtCodigoMaterial" #txtCodigoMaterial maxlength="20"
                                    formControlName="codigo_material">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtCodigoMaterial.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.codigo_material)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                                floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Peneira
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <mat-select id="txtPeneira" #txtPeneira formControlName="peneira"
                                    disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterPeneiraBasic($event.target.value)" />
                                    <mat-option *ngFor="let item of listPeneiraBasic" [value]="item.name">
                                        {{ item.name | uppercase }}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{ iconEnableField }}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.peneira)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>


        <!-- Pré-Básica-->
        <mat-card class="mat-elevation-z8 w-100" *ngIf="isPreBasica">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">
                    <!-- Linha 1 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Centro de Ensaque
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtCentroEnsaque" #txtCentroEnsaque maxlength="50"
                                    formControlName="centro_ensaque" disabled class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="end">{{txtCentroEnsaque.value.length}} / 50</mat-hint>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.contrato_juridico)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">{{hintSafraPreBasicaLabel}}</mat-label>
                                <input (blur)="makeCalc()" matInput id="txtSafra" #txtSafra maxlength="5"
                                    formControlName="safra_basica" required>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintSafraPreBasica}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.safra)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Nº de Campo (Básica)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtNumCampo" #txtNumCampo maxlength="10"
                                    formControlName="numero_campo" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }" (blur)="makeCalc()"
                                    [readonly]="disableNumeroCampo" [class.InputBlockColor]="disableNumeroCampo">
                                <i matSuffix class="{{iconDisableField}}" *ngIf="disableNumeroCampo"></i>
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!disableNumeroCampo"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtNumCampo.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.numero_campo)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 2 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Contrato Jurídico
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtContrato" #txtContrato maxlength="50"
                                    formControlName="contrato_juridico" disabled class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="end">{{txtContrato.value.length}} / 50</mat-hint>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.contrato_juridico)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Ordem de Processo
                                </mat-label>
                                <input matInput id="txtOrdemProcesso" #txtOrdemProcesso maxlength="20"
                                    formControlName="ordem_processo">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtOrdemProcesso.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.ordem_processo)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>


                    <!-- Linha 3 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Híbrido/Linhagem
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtHibrido" #txtHibrido maxlength="80" [readonly]="true"
                                    formControlName="hibrido_rnc" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtHibrido.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.hibrido_rnc)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Espécie
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtEspecie" #txtEspecie maxlength="20" formControlName="especie"
                                    [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtEspecie.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.especie)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Geração
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtGeracao" #txtGeracao maxlength="20" formControlName="geracao"
                                    [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtGeracao.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.geracao)}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                    </div>

                    <!-- Linha 5 -->

                    <div class="row pt-3">
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Lote de Origem
                                </mat-label>
                                <input matInput id="txtLoteOrigem" #txtLoteOrigem maxlength="10"
                                    formControlName="lote_origem" [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    Somente letras, números e undelines são permitidos(tamanho exato de 10)
                                </mat-hint>
                                <mat-hint align="end">{{txtLoteOrigem.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.lote_origem)}}</mat-error>
                            </mat-form-field>

                        </div> -->
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                                floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Peneira
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <mat-select id="txtPeneira" #txtPeneira formControlName="peneira"
                                    disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterPeneiraBasic($event.target.value)" />
                                    <mat-option *ngFor="let item of listPeneiraBasic" [value]="item.name">
                                        {{ item.name | uppercase }}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{ iconEnableField }}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.peneira)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Lote de Saída
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>

                                <mat-select #txtLoteSaida formControlName="lote_saida" disableCenteringOption>
                                    <mat-option *ngFor="let item of listLoteSaida" [value]="item.lote_pa"
                                        (changeSelection)="makeCalculations()">
                                        {{ item.lote_pa | uppercase }}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>

                                <mat-error>{{hasErrorFormControl(formulario.controls.lote_saida)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Status do Lote
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtStatusLote" #txtStatusLote maxlength="10"
                                    formControlName="status_lote" [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtStatusLote.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.status_lote)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 6 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Código do Material</mat-label>
                                <input matInput id="txtCodigoMaterial" #txtCodigoMaterial maxlength="20"
                                    formControlName="codigo_material">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtCodigoMaterial.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.codigo_material)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso PA (kgs)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txPesoPA" #txPesoPA formControlName="peso_pa" currencyMask
                                    [options]="{ thousands: '', decimal: ',', precision: 2 }"
                                    (blur)="calcPesoTotal($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-error>Valo máximo de 20 kgs</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso Mil Sementes (PMS)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtPMS" #txtPMS formControlName="peso_mil_sementes" currencyMask
                                    [options]="{ thousands: '', decimal: ',', precision: 0 }"
                                    (blur)="calcPesoTotal($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Número de sementes no saco</mat-label>
                                <input matInput id="txtNumSementesSaco" #txtNumSementesSaco maxlength="20"
                                    formControlName="num_sementes_saco" [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.num_sementes_saco)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Quantidade de sacos
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtNumSementesSaco" #txtNumSementesSaco maxlength="20"
                                    formControlName="total_sacos" currencyMask
                                    [options]="{ thousands: '', decimal: ',', precision: 0 }"
                                    (blur)="calcPesoTotal($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.total_sacos)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso Total
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtPesoTotal" #txtPesoTotal maxlength="20"
                                    formControlName="peso_total_lote_kg" [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtPesoTotal.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.peso_total_lote_kg)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Data Ensaque
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtDataEnsaque" #txtDataEnsaque maxlength="10"
                                    [dropSpecialCharacters]="false" mask="d0/M0/0000" formControlName="data_ensaque"
                                    (blur)="calcDatesEvent($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtDataEnsaque.value.length}} / 20</mat-hint> <mat-error
                                    *ngIf="formulario.controls.data_ensaque.hasError('dateHighThanActual')">A
                                    data não pode ser maior que a data atual</mat-error>
                                <mat-error>{{hasErrorFormControl(formulario.controls.data_ensaque)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Linha de Ensaque
                                </mat-label>
                                <mat-select formControlName="linha_ensaque" disableCenteringOption>
                                    <mat-option *ngFor="let item of listLinhaEnsaque" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tamanho da Sacaria
                                </mat-label>
                                <mat-select formControlName="tamanho_da_sacaria" disableCenteringOption>
                                    <mat-option *ngFor="let item of listTamanhoSacaria" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Código da Embalagem</mat-label>
                                <input matInput id="txtCodigoEmbalagem" #txtCodigoEmbalagem maxlength="20"
                                    formControlName="codigo_embalagem">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtCodigoEmbalagem.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.codigo_embalagem)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Perda de embalagem - erro de impressão</mat-label>
                                <input matInput id="txtErroImpressao" #txtErroImpressao maxlength="20"
                                    formControlName="perdas_embalagens_erro_impressao" currencyMask
                                    [options]="{ thousands: '', decimal: ',', precision: 0 }"
                                    (blur)="calcPerdas($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.perdas_embalagens_erro_impressao)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Perda de embalagem - erro de costura</mat-label>
                                <input matInput id="txtErroCostura" #txtErroCostura maxlength="20"
                                    formControlName="perdas_embalagens_erro_costura" currencyMask
                                    [options]="{ thousands: '', decimal: ',', precision: 0 }"
                                    (blur)="calcPerdas($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.perdas_embalagens_erro_costura)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Perda de embalagem - outros erros</mat-label>
                                <input matInput id="txtOutrosErros" #txtOutrosErros maxlength="20"
                                    formControlName="perdas_embalagens_outras_ocorrencias" currencyMask
                                    [options]="{ thousands: '', decimal: ',', precision: 0 }"
                                    (blur)="calcPerdas($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.perdas_embalagens_outras_ocorrencias)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Quantidade de embalagens canguru</mat-label>
                                <input matInput id="txtEmbalagemCanguru" #txtEmbalagemCanguru maxlength="20"
                                    formControlName="qntd_embalagem_canguru" currencyMask
                                    [options]="{ thousands: '', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.qntd_embalagem_canguru)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Total perda de embalagens</mat-label>
                                <input matInput id="txtPerdaTotal" #txtPerdaTotal
                                    formControlName="total_perdas_embalagens" currencyMask
                                    [options]="{ thousands: '', decimal: ',', precision: 0 }" [readonly]="true"
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.total_perdas_embalagens)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Quantidade de embalagens</mat-label>
                                <input matInput id="txtQtdEmbalagem" #txtQtdEmbalagem
                                    formControlName="quantidade_embalagens_un" currencyMask
                                    [options]="{ thousands: '', decimal: ',', precision: 0 }" [readonly]="true"
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.quantidade_embalagens_un)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Descarte Tratado</mat-label>
                                <input matInput id="txtDescate" #txtDescate maxlength="20"
                                    formControlName="descarte_tratado_kg" [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtDescate.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.descarte_tratado_kg)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>